import { useEffect, useState } from 'react';

import { CloudUploadOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import MyDocumentListTemplate from './MyDocumentList.template';
import { Filter, FilterType } from '../../../admin/pages/Interfaces';
import { FileToUpload } from '../../../../app/RequestInterfaces';
import { translations } from '../../../../utils/LocalizedStrings';
import { GetMyDocumentListAction, StoreAction, UploadMyDocumentAction } from '../../../../app/ActionsImpl';

const filtersConfig: Filter[] = [
  {
    name: "fileName",
    translation: "Názov súboru",
    value: "",
    type: FilterType.STRING,
    selected: false
  },
  {
    name: "created_at-$gte",
    translation: "Vytvorené od",
    value: "",
    type: FilterType.DATE_TIME,
    selected: false
  },
  {
    name: "created_at-$lte",
    translation: "Vytvorené do",
    value: "",
    type: FilterType.DATE_TIME,
    selected: false
  }
]

export interface Props extends StateProps, DispatchProps { }


const MyDocumentListPage = (props: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortBy, setSortBy] = useState("updated_at")
  const [sortDir, setSortDir] = useState("DSC")
  const [filters, setFiltersValues] = useState(JSON.parse(JSON.stringify(filtersConfig)))
  const [selectedFilters, setSelectedFilters] = useState<string[]>([])

  async function getMyDocumentList() {
    await props.getMyDocumentList(page, perPage, sortBy, sortDir, parseFilters())
    setIsLoading(false)
  }

  useEffect(() => {
    getMyDocumentList()
  }, []);

  // const refresh = () => {
  //   getMyDocumentsList()
  // }

  useEffect(() => {
    console.log("LOAD DOCUMENTS MY")
    if (props.user) {
      getMyDocumentList()
    }
  }, [props.user]);


  const handleFileChange = async (event: any) => {
    for (let oneFile of event.target.files) {
      // console.log(event.target.files)
      let reader = new FileReader();
      reader.onload = async (loadEvent: any) => {
        let tmp1: FileToUpload = {
          name: oneFile.name,
          content: reader.result,
        };
        props.uploadMyDocuments([tmp1])
      };
      await reader.readAsDataURL(oneFile);
      // await refresh();
    }

  };


  const setFilters = (filterName: string) => {
    let selectedFiltersCopy: string[] = selectedFilters
    if (selectedFiltersCopy.indexOf(filterName) !== -1) {
      selectedFiltersCopy.splice(selectedFiltersCopy.indexOf(filterName), 1)
      for (let filter of filters) {
        if (filter.name === filterName) {
          filter.value = ""
        }
      }
    } else {
      selectedFiltersCopy.push(filterName)
    }
    setSelectedFilters(selectedFiltersCopy)
  }

  const filtersCount = () => {
    let count = 0
    for (let filter of filters) {
      if (filter.value !== "") {
        count += 1
      }
    }
    return count
  }

  const parseFilters = () => {
    let filterUri = ""
    let index = 0
    for (let filter of filters) {
      if (filter.value !== "") {
        filterUri += filter.name + "=" + filter.value
        index += 1
        if (index !== filtersCount()) {
          filterUri += "&"
        }
      }
    }
    return filterUri
  }

  const pageChange = async (value: number, size?: number) => {
    setIsLoading(true);
    setPage(value)
    if (size) {
      setPerPage(size)
    }
    await props.getMyDocumentList(value, size ? size : perPage, sortBy, sortDir, parseFilters());
    setIsLoading(false);
  }

  const sortByChange = async (value: string) => {
    setIsLoading(true);
    let newSortDir = "DSC"
    if (sortBy === value) {
      if (sortDir === "DSC") {
        newSortDir = "ASC"
      }
    } else {
      setSortBy(value)
    }
    setSortDir(newSortDir)
    await props.getMyDocumentList(page, perPage, value, newSortDir, parseFilters());
    setIsLoading(false);
  }

  return <>
    <span
      className="orderItemUploadIcons"
      style={{ margin: '10px auto' }}>
      <input
        onChange={handleFileChange}
        style={{ display: 'none' }}
        id="textract_upload_picker"
        type="file"
        multiple
      />
      <label
        htmlFor="textract_upload_picker"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 10,
        }}>
        <CloudUploadOutlined className="importPicture" />
        <b>{translations.artifacts.MyDocumentsListPage?.uploadFile}</b>
      </label>
    </span>
    {props.documentsList &&
      < MyDocumentListTemplate selectedFilters={selectedFilters} setFilters={setFilters} filters={filters} setSortBy={(value: string) => sortByChange(value)} sortBy={sortBy} sortDir={sortDir} pageChange={(value: number, size?: number) => pageChange(value, size)} documents={props.documentsList} isLoading={isLoading} refresh={getMyDocumentList} />
    }
  </>
};

const mapStateToProps = ({ appState }: any) => ({
  documentsList: appState.documentsList,
  user: appState.cognitoUser
});

interface DispatchProps {
  getMyDocumentList: (page: number, size: number, orderBy: string, orderDir: string, filters: string) => void;
  uploadMyDocuments: (files: FileToUpload[]) => void;

}

function mapDispatchToProps(dispatch: Dispatch<StoreAction, any>): DispatchProps {
  return {
    getMyDocumentList: (page: number, size: number, orderBy: string, orderDir: string, filters: string) => dispatch(GetMyDocumentListAction(page, size, orderBy, orderDir, filters)),
    uploadMyDocuments: (files: FileToUpload[]) => dispatch(UploadMyDocumentAction(files))
  }
};

type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(MyDocumentListPage)
